export { default } from './BuyCard';
